import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Collapse, Col } from 'react-bootstrap';
import 'components/admin/service-providers/ServiceProvidersDetails.css';
import RouteTitle from 'components/shared/route-title/RouteTitle';
import DetailsHeader from 'components/shared/details/DetailsHeader';
import ContractorStatus from 'components/admin/contractors/ContractorStatus';
import DetailsInfo from 'components/shared/details/DetailsInfo';
import DetailsInfoItem from 'components/shared/details/DetailsInfoItem';
import {
  getCompanyData,
  getUserList,
  getUserForm,
  getShowInviteUserModal,
  getShowConfirmationDeleteModal,
} from 'components/admin/service-providers/store/selectors';
import { formatPhoneNumber } from 'services/utils/text-util';
import LogoUpload from 'components/shared/logo-upload/LogoUpload';
import { simpleScrollToTop } from 'services/utils/scroller-util';
import {
  loadServiceProviderById,
  loadServiceProvidersUser,
  setCurrentUserId,
  setShowEditUserModal,
  loadUserForm,
  editUser,
  deleteUser,
  inviteUser,
  setShowConfirmationModal,
  goToEditServiceProvider,
} from 'components/admin/service-providers/store/actions';
import { ServiceProviderOptionsUrlToValues } from 'domain/service-provider-type-enum';
import { clearUserData } from 'components/admin/service-providers/store/actions';
import UserTable from 'components/admin/service-providers/UserTable';
import StampDetails from 'components/shared/stamp/StampDetails';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faAngleDown from '@fortawesome/fontawesome-free-solid/faAngleDown';
import faAngleUp from '@fortawesome/fontawesome-free-solid/faAngleUp';

class ServiceProvidersDetails extends Component {
  constructor(props) {
    super(props);
    const { match } = this.props;
    this.type = match
      ? ServiceProviderOptionsUrlToValues.get(match.params.type)
      : props.type;
    this.typeUrl = match ? match.params.type : props.type;
    this.serviceProviderId = match ? match.params.id : props.id;
    this.state = { showStamp: false };
  }

  componentDidUpdate() {
    simpleScrollToTop();
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(loadServiceProviderById(this.type, this.serviceProviderId));
    dispatch(loadServiceProvidersUser(this.type, this.serviceProviderId));
  }

  handleEdit = () => {
    const { dispatch } = this.props;
    dispatch(goToEditServiceProvider(this.typeUrl, this.serviceProviderId));
  };

  handleUserSelection = (index) => {
    const { dispatch, users } = this.props;
    dispatch(setCurrentUserId(users[index].id));
    dispatch(loadUserForm(users[index]));
    dispatch(setShowEditUserModal(true));
  };

  handleShowStamp = () => {
    this.setState({ showStamp: !this.state.showStamp });
  };

  render() {
    let detailsInfoItems = [];
    const { companyData, users } = this.props;

    if (companyData) {
      if (companyData.location) {
        detailsInfoItems.push(
          <DetailsInfoItem
            lines={[
              companyData.location.street_address_1,
              `${companyData.location.city}, ${companyData.location.state} ${companyData.location.zip}`,
            ]}
            title="ADDRESS"
          />
        );
      }

      detailsInfoItems.push(
        <DetailsInfoItem
          lines={[
            <span className="general-contractor-name">
              {`${companyData.contact.first_name} ${companyData.contact.last_name}`}
            </span>,
            <a
              className="general-contractor-email"
              href={`mailto:${companyData.contact.email}`}
            >
              {companyData.contact.email}
            </a>,
            formatPhoneNumber(companyData.contact.phone_number),
          ]}
          title={
            <div>
              <span>PRIMARY CONTACT</span>
            </div>
          }
        />
      );

      const { showStamp } = this.state;
      detailsInfoItems.push(
        <DetailsInfoItem
          lines={[
            <Collapse in={showStamp} className="collapse-info">
              <div>
                <Col md={12}>
                  <StampDetails
                    companyName={companyData.name}
                    companyLogo={companyData.logo}
                    stamp={companyData.stamp}
                    value="approved"
                  />
                </Col>
                <div className="clearfix" />
              </div>
            </Collapse>,
          ]}
          title={
            <div
              className="details-info-item-stamp"
              onClick={this.handleShowStamp}
            >
              <span>STAMP</span>
              <span>
                <FontAwesomeIcon icon={showStamp ? faAngleUp : faAngleDown} />
              </span>
            </div>
          }
        />
      );
    }

    return (
      <div className="service-provider-details">
        <RouteTitle titles={['COMPANY', companyData.name.toUpperCase()]} />

        <DetailsHeader
          leftHeader={{
            title: 'COMPANY',
            value: companyData.name,
          }}
          leftHeaderExtraComponents={
            companyData.logo &&
            companyData.logo.image && (
              <div className="logo-preview-container">
                <LogoUpload
                  extensions={['.jpg', '.jpeg', '.gif', '.png']}
                  logos={[
                    {
                      preview: companyData.logo.image.url,
                      url: companyData.logo.image.url,
                    },
                  ]}
                  readOnly={true}
                />
              </div>
            )
          }
          rightHeaders={[
            [
              {
                title: 'STATUS',
                value: <ContractorStatus status={companyData.status} />,
              },
            ],
          ]}
        />

        <div className="details-info-container">
          <DetailsInfo
            itemsContainerSize={12}
            itemsLines={[detailsInfoItems]}
          />

          <div className="edit-button-container">
            <input
              type="button"
              className="btn button button-gray"
              value="Edit"
              onClick={this.handleEdit}
            />
          </div>
        </div>

        {users && <UserTable type={this.type} />}
      </div>
    );
  }

  handleCloseEditUserModal = () => {
    const { dispatch } = this.props;
    dispatch(setShowEditUserModal(false));
  };

  handleInviteClient = () => {
    const { dispatch } = this.props;
    dispatch(clearUserData());
    dispatch(setShowEditUserModal(true));
  };

  handleEditUserOnSubmit = (values) => {
    const { dispatch, companyData, user } = this.props;
    if (user) {
      dispatch(editUser(values, companyData.type, companyData.id));
    } else {
      dispatch(inviteUser(values, companyData.type, companyData.id));
    }
  };

  handleDeleteEditUserModal = (response) => {
    const { user, dispatch, companyData } = this.props;
    if (response) {
      dispatch(deleteUser(user, companyData.type, companyData.id));
    }
    dispatch(setShowConfirmationModal(false));
  };

  handleShowConfirmationDelete = () => {
    const { dispatch } = this.props;
    dispatch(setShowConfirmationModal(true));
  };

  mapServiceProviders = (serviceProviders) => {
    return serviceProviders.map((serviceProvider) => {
      return [
        serviceProvider.first_name !== null
          ? `${serviceProvider.first_name} ${serviceProvider.last_name}`
          : 'N/A',
        <span className="h4">{serviceProvider.title}</span>,
        <ContractorStatus status={serviceProvider.status} />,
        serviceProvider.email !== null ? serviceProvider.email : 'N/A',
        `${formatPhoneNumber(serviceProvider.phone_number)}${
          serviceProvider.phone_ext ? ` ext ${serviceProvider.phone_ext}` : ''
        }`,
      ];
    });
  };
}

export default connect((state) => {
  return {
    companyData: getCompanyData(state),
    users: getUserList(state),
    user: getUserForm(state),
    showInviteUserModal: getShowInviteUserModal(state),
    showConfirmationDeleteModal: getShowConfirmationDeleteModal(state),
  };
})(ServiceProvidersDetails);



// WEBPACK FOOTER //
// ./src/components/admin/service-providers/ServiceProvidersDetails.js